import { createApi } from "@reduxjs/toolkit/query/react";
import { convertTag, Endpoints } from "services/urls";
import { baseQuery } from "../utils/baseQuery";
import { ILeaveReport, ILeaveReportQuery, IProfile } from "types/auth.types";
import { apiHelper } from "utils/apiHelper";
import { AUTH_TAGS } from "constants/API_TAGS";

const AuthApi = createApi({
  reducerPath: "auth-api",
  baseQuery: baseQuery(),
  tagTypes: [AUTH_TAGS.profile],
  endpoints: (builder) => ({
    // LOGIN
    // username | password
    login: builder.mutation({
      invalidatesTags: [convertTag(AUTH_TAGS.profile)],
      query: (body) => ({
        url: Endpoints.auth.login,
        method: "POST",
        body,
      }),
    }),
    logout: builder.mutation({
      query: () => ({
        url: Endpoints.auth.logout,
        method: "GET",
      }),
    }),
    profile: builder.query<IProfile, unknown>({
      providesTags: [convertTag(AUTH_TAGS.profile)],
      query: () => Endpoints.profile.get,
    }),
    editProfile: builder.mutation({
      invalidatesTags: [convertTag(AUTH_TAGS.profile)],
      query: (body) => ({
        url: Endpoints.profile.edit,
        method: "POST",
        body,
      }),
    }),
    leaveReport: builder.query<ILeaveReport, ILeaveReportQuery>({
      query: (body) => apiHelper(Endpoints.auth.leaveReport, body),
    }),
    forgetPassword: builder.mutation({
      query: (body) => ({
        url: Endpoints.auth.forgetpassword,
        body,
        method: "POST",
      }),
    }),
    forgetPasswordVerify: builder.mutation({
      query: (body) => ({
        url: Endpoints.auth.forgetpasswordVerify,
        body,
        method: "POST",
      }),
    }),
    resetPassword: builder.mutation({
      query: (body) => ({
        url: Endpoints.auth.resetpassword,
        body,
        method: "POST",
      }),
    }),
    getReport: builder.mutation({
      query: (url) => ({
        url,
        method: "GET",
      }),
    }),
    getAllActiveUsers: builder.query<{ users: any[] }, void>({
      query: () => "/users",
    }),
    getAllActiveUsersForMeeting: builder.query<{ users: any[] }, void>({
      query: () => "/users/all",
    }),
    getTeamMembers: builder.query<{ users: any[] }, void>({
      query: () => "/user/team-members",
    }),
  }),
});

export const {
  useLoginMutation,
  useProfileQuery,
  useLogoutMutation,
  useForgetPasswordMutation,
  useForgetPasswordVerifyMutation,
  useResetPasswordMutation,
  useLeaveReportQuery,
  useEditProfileMutation,
  useGetReportMutation,
  useGetAllActiveUsersQuery,
  useGetAllActiveUsersForMeetingQuery,
  useGetTeamMembersQuery,
} = AuthApi;
export { AuthApi };
